import BaseService from "../BaseService";
import _ from "lodash";

class CtvService extends BaseService {

    me = async (filter) => {
        var data = await this._api.post("store/ctv/me",filter);
        return data;
    };


    
    productList = async () => {
        var data = await this._api.post("store/ctv/productlist");
        return data;
    };

    transactions = async (filter) => {
        var data = await this._api.post("store/ctv/transactions", filter);
        return data;
    };

    withdrawRequest = async ({ amount } = {}) => {
        var data = await this._api.post("store/ctv/withdraw_request", { amount });
        return data;
    };




}
export default CtvService;
